/* OI Judge.me widget fix — v6 (disable v2025, force legacy) */
(function(){
  'use strict';

  function disableV2025AndShowLegacy(){
    /* Find all v2025 widget wrappers and disable them */
    var v2025Widgets = document.querySelectorAll(
      '.jdgm-all-reviews-widget-v2025, [data-widget="all-reviews-v2025"], [data-entry-point*="v2025"]'
    );

    v2025Widgets.forEach(function(w){
      /* Remove v2025 attributes so loader.js does NOT try to load the v2025 bundle */
      w.removeAttribute('data-entry-point');
      w.removeAttribute('data-entry-key');
      w.removeAttribute('data-widget');

      /* Find and show the legacy content */
      var legacy = w.querySelector('.jdgm-legacy-widget-content');
      if(legacy){
        legacy.style.cssText = 'display: block !important; visibility: visible !important;';

        /* Remove all temp-hiding styles within legacy */
        legacy.querySelectorAll('style.jdgm-temp-hiding-style').forEach(function(s){ s.remove(); });

        /* Unhide the main widget article */
        legacy.querySelectorAll('.jdgm-all-reviews-widget, .jdgm-rev-widg').forEach(function(el){
          el.style.cssText = 'display: block !important; visibility: visible !important;';
        });

        /* Unhide histogram */
        legacy.querySelectorAll('.jdgm-histogram.jdgm-temp-hidden').forEach(function(el){
          el.classList.remove('jdgm-temp-hidden');
        });
      }

      /* Hide any broken v2025 rendered content (direct children that are NOT the legacy wrapper) */
      for(var i=0; i<w.children.length; i++){
        var child = w.children[i];
        if(!child.classList.contains('jdgm-legacy-widget-content') && child.tagName !== 'STYLE'){
          child.style.display = 'none';
        }
      }
    });
  }

  function removeGlobalTempHiding(){
    document.querySelectorAll('style.jdgm-temp-hiding-style').forEach(function(s){ s.remove(); });

    document.querySelectorAll('.jdgm-rev-widg').forEach(function(el){
      el.style.removeProperty('display');
    });
    document.querySelectorAll('.jdgm-carousel').forEach(function(el){
      el.style.removeProperty('display');
    });
  }

  function fixLazyImages(){
    document.querySelectorAll('img[data-src]').forEach(function(img){
      if(!img.src || img.src === '' || img.src === window.location.href){
        var src = img.getAttribute('data-src-retina') || img.getAttribute('data-src');
        if(src) img.src = src;
      }
    });
  }

  function tryJdgmInit(){
    if(window.jdgm && typeof jdgm.init === 'function'){
      try{ jdgm.init(); }catch(e){}
    }
  }

  function runFixes(){
    disableV2025AndShowLegacy();
    removeGlobalTempHiding();
    fixLazyImages();
  }

  /* Run IMMEDIATELY to prevent v2025 loader from starting */
  runFixes();

  /* Also run on DOMContentLoaded and after delays */
  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', function(){
      runFixes();
      setTimeout(runFixes, 500);
      setTimeout(function(){ runFixes(); tryJdgmInit(); }, 2000);
      setTimeout(runFixes, 4000);
      setTimeout(runFixes, 8000);
    });
  } else {
    setTimeout(runFixes, 100);
    setTimeout(runFixes, 500);
    setTimeout(function(){ runFixes(); tryJdgmInit(); }, 2000);
    setTimeout(runFixes, 4000);
    setTimeout(runFixes, 8000);
  }

  /* MutationObserver for dynamically added content */
  var debounce = null;
  var obs = new MutationObserver(function(){
    if(debounce) clearTimeout(debounce);
    debounce = setTimeout(function(){ runFixes(); }, 200);
  });
  obs.observe(document.documentElement, {childList:true, subtree:true});
})();
